var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"eva-pre",class:_vm.classes,style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }